import React, { useState } from 'react';
import './FAQs.css';

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqData = [
        {
            question: 'What is BMI?',
            answer: 'BMI (Body Mass Index) is a value derived from the weight and height of an individual. It is used to categorize individuals into different weight ranges such as underweight, normal, overweight, and obese.',
        },
        {
            question: 'How is BMI calculated?',
            answer: 'BMI is calculated by dividing your weight (in kilograms) by your height (in meters) squared. Alternatively, you can use pounds and inches, with the formula BMI = (weight in lbs ÷ height in inches²) × 703.',
        },
        {
            question: 'What is a healthy BMI range?',
            answer: 'A healthy BMI is generally considered to be between 18.5 and 24.9. Below this range is considered underweight, and above this range is considered overweight or obese.',
        },
        {
            question: 'Can BMI differentiate between muscle and fat?',
            answer: 'No, BMI does not differentiate between weight from muscle and weight from fat. Individuals with high muscle mass may have a high BMI but not have excess body fat.',
        },
        {
            question: 'Is BMI accurate for everyone?',
            answer: 'BMI is a useful indicator for the general population but may not be accurate for athletes, pregnant women, the elderly, or individuals with a high muscle mass. For more accurate health assessments, consult with a healthcare professional.',
        },
        {
            question: 'What are the risks of a high BMI?',
            answer: 'A high BMI can increase the risk of developing conditions like heart disease, type 2 diabetes, high blood pressure, and certain types of cancer. It is important to maintain a healthy weight to reduce these risks.',
        },
        // Additional SEO-related questions
        {
            question: 'How to calculate BMI value?',
            answer: 'To calculate BMI, divide your weight in kilograms by your height in meters squared. If you are using pounds and inches, the formula is BMI = (weight in pounds ÷ height in inches²) × 703.',
        },
        {
            question: 'BMI calculation formula',
            answer: 'The formula for BMI calculation is: BMI = weight (kg) ÷ height (m)². Alternatively, BMI = (weight in lbs ÷ height in inches²) × 703.',
        },
        {
            question: 'How to calculate BMI of a person?',
            answer: 'To calculate BMI for a person, use the formula: BMI = weight (kg) ÷ height (m)². For pounds and inches, use the formula BMI = (weight in lbs ÷ height in inches²) × 703.',
        },
        {
            question: 'BMI calculator for women',
            answer: 'A BMI calculator for women works the same as any other BMI calculator. It calculates BMI by dividing weight in kilograms by height in meters squared. It can help women understand if they are in the underweight, healthy, overweight, or obese category.',
        },
        {
            question: 'Maintenance calorie calculator',
            answer: 'A maintenance calorie calculator estimates how many calories you need to consume each day to maintain your current weight based on factors like age, gender, weight, height, and activity level.',
        },
    ];

    const toggleAnswer = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="faq-container" id="faq">
            <h2>Frequently Asked Questions about BMI</h2>
            {faqData.map((item, index) => (
                <div key={index} className="faq-item">
                    <div
                        className="faq-question"
                        onClick={() => toggleAnswer(index)}
                    >
                        {item.question}
                        <span className="faq-toggle-icon">
                            {activeIndex === index ? '-' : '+'}
                        </span>
                    </div>
                    {activeIndex === index && (
                        <div className="faq-answer">{item.answer}</div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default FAQ;
